import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  editor: {
    margin: 0,
    marginTop: 20,
  },
  title: {
    marginBottom: "4px",
  },
}));
